// import React from 'react'

// const CreateTaxandCharges = () => {
//   return (
//     <div>

//     </div>
//   )
// }

// export default CreateTaxandCharges

//----------------imports---------------------
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, Autocomplete } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import AddToolbar from "../../components/common/AddToolbar";
import { Slide } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { useSelector, useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import {
  ENUSER,
  MAPLOCATION_API_01,
  SETTINGS_API_07,
  TAX_API_01,
  TAX_API_02,
} from "../../api/ApiModel";
import {
  COMPCODE,
  LOCCODE,
  RESTCODE,
  STS,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";

const CreateTaxandCharges = () => {
  //----------------hooks----------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERREFCODE, RESTCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const [data, setData] = useState(null);
  const [dataAddon, setDataAddon] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { selectedItem, LOCCODE } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const isEdit = location.state?.actionText === "Edit";
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState([]);
  const options1 = [
    { label: "Gross", value: "G" },
    { label: "Nett", value: "N" },
  ];
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    TAXTYPE: "",
    TAXAPPLIED: "",
    LOCCODE: "",
    TAXRATE: "",
    TAXCODE: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        TAXTYPE: selectedItem.TAXTYPE,
        TAXAPPLIED: selectedItem.TAXAPPLIEDFOR,
        TAXRATE: String(selectedItem.TAXRATE),
        TAXCODE: String(selectedItem.TAXCODE),
        LOCCODE: LOCCODE,
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(MAPLOCATION_API_01, "get", {
          COMPCODE,
          USERREFCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result); // Populate orderData with the updated array
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  //-------------------functions----------------
  const fetchData = async () => {
    try {
      const result = await externalgetApi(TAX_API_01, "get", {
        COMPCODE,
        LOCCODE,

        STS: CON_STATUS_ACTIVE,
      });
      setDataAddon(result);
    } catch (err) {
      setError(err);
    }
  };

  const gotToView = () => {
    navigate("/ViewtaxCharges");
  };

  // Handlers-----------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };
  //Postapi
  const handleConfirmClick = async () => {
    const { TAXTYPE, TAXAPPLIEDFOR, TAXRATE } = selectedItemDetails;

    const requiredFields = [
      { name: "TAXTYPE", value: TAXTYPE, label: "Add on Type" },
      { name: "TAXRATE", value: TAXRATE, label: "  TAXRATE" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    if (dataAddon) {
      const isDuplicate = dataAddon.some((item) => {
        if (
          item.TAXCODE != selectedItemDetails.TAXCODE &&
          item.TAXTYPE === TAXTYPE
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setSnackbarMessage("Add On Name already exists."); // Show snackbar if duplicate found
        setOpenErrorSnackbar(true);
        return;
      }
    }

    const staticValues = {
      COMPCODE,

      lOCDATE: new Date().toISOString().split("T")[0],
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(TAX_API_02, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        TAXTYPE: "",
        TAXAPPLIEDFOR: "",
        TAXRATE: "",
        TAXCODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/ViewtaxCharges");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      TAXTYPE: "",
      TAXAPPLIEDFOR: "",
      TAXRATE: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  //validations
  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError(""); // Clear any existing error message
      handleInputChange(event); // Update state with the valid input
    } else {
      setError("Only numbers and floats are allowed."); // Set error message
    }
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Tax</Link>
                <Link underline="none"> Create Tax</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit
              ? "Edit Tax & Charges Types"
              : "Add Tax & Charges Types",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <Autocomplete
              options={Array.isArray(dataloc) ? dataloc : []}
              getOptionLabel={(option) => option.LOCATION || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Location"
                  label={
                    <span>
                      Location<span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  size="small"
                  variant="outlined"
                  error={Boolean(errors.LOCCODE)}
                  helperText={errors.LOCCODE}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 150,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
              value={
                dataloc.find(
                  (loc) => loc.LOCCODE === selectedItemDetails.LOCCODE
                ) || null
              }
              error={Boolean(errors.LOCCODE)}
              helperText={errors.LOCCODE}
              onChange={(event, newValue) => {
                setSelectedItemDetails((prevDetails) => ({
                  ...prevDetails,
                  LOCCODE: newValue ? newValue.LOCCODE : "",
                }));

                // Clear the error for LOCCODE when a value is selected
                setErrors((prevErrors) => ({
                  ...prevErrors,
                  LOCCODE: "",
                }));
              }}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Tax / Charges Type<span style={{ color: "red" }}> *</span>
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="TAXTYPE"
              value={selectedItemDetails.TAXTYPE}
              onChange={handleInputChange}
              error={Boolean(errors.TAXTYPE)}
              helperText={errors.TAXTYPE}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Tax / Charges Rate <span style={{ color: "red" }}> *</span>
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="TAXRATE"
              value={selectedItemDetails.TAXRATE}
              onChange={handlenumInputValidation} // Ensure function is correctly used
              error={Boolean(errors.TAXRATE)}
              helperText={errors.TAXRATE}
              disabled={isEdit}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl size="small" fullWidth>
              <Autocomplete
                options={options1}
                getOptionLabel={(option) => option.label}
                value={
                  options1.find(
                    (option) => option.value === selectedItemDetails.TAXAPPLIED
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "TAXAPPLIED",
                      value: newValue ? newValue.value : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tax Applied"
                    variant="outlined"
                    size="small"
                    helperText={error?.TAXAPPLIED}
                    error={!!error?.TAXAPPLIED}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
                noOptionsText={
                  <div
                    style={{
                      backgroundColor: theme.palette.background.paper,
                      padding: "8px",
                    }}
                  >
                    No options
                  </div>
                }
                disabled={isEdit}
              />
            </FormControl>
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default CreateTaxandCharges;
